<div class="row estimates-header">
  <div class="col-lg-12 mt-4">
    <div class="header-title" style="margin-top: 30px">{{'' | i18n: 'messages'}}</div>
  </div>
</div>
<div class="row detail-container">
  <div class="filter-container">
    <div class="row">
      <div class="col-12">
        @for (m of messages; track m) {
          <div [ngClass]="{'unread': m.messageRead==false}" class="message"
            (click)="readSpecialRequest(m.id)">
            @if (m?.declineReason != null && m?.contractNumber == null && m?.id == 1) {
              <div>
                {{'' | i18n: m.declineReason}}
              </div>
            }
            @if (m?.declineReason == null && !isAdmin()) {
              <div>
                {{this.interpolateTemplate('' | i18n: 'message-contract-approved', {
                contractNumber: m.contractNumber,
                vin: m.vin,
                owner: m.ownerInitials + ' ' + m.lastName
                })}}
              </div>
            }
            @if (m?.declineReason != null && m?.declineReason != 'processing-bulk-warranty-contract-file-error' && !isAdmin()) {
              <div
                >
                {{this.interpolateTemplate('' | i18n: 'message-contract-rejected', {
                contractNumber: m.contractNumber,
                vin: m.vin,
                owner: m.ownerInitials + ' ' + m.lastName,
                rejectionReason: m.declineReason
                })}}
              </div>
            }
            @if (m?.declineReason != null && m?.declineReason == 'processing-bulk-warranty-contract-file-error' && isAdmin()) {
              <div
                >
                {{this.interpolateTemplate('' | i18n: 'processing-bulk-warranty-contract-file-error', {})}}
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">&nbsp;</div>
  </div>
</div>
